import React from 'react';
import qs from 'qs';
import info from 'configs/cards';
import {
  Wrap,
  Bg,
  Content,
  Block,
  TextWrap,
  Title,
  Desc,
  Card,
  ReturnBtn,
  CardWrap
} from './Styles';
import { track, trackMap } from 'track';

const List = props => {
  const { type } = qs.parse(props.location.search.slice(1));
  const list = info[type];

  const clickCard = ({ trackName, index }) => {
    track(trackMap[trackName]);
    props.history.replace({
      pathname: '/card',
      search: `?type=${type}&card=${index}&fromList=true`
    });
  };

  return (
    <Wrap>
      <Bg />
      <Content>
        {list.map(({ title, desc, img, trackName }, index) => (
          <Block key={index} onClick={() => clickCard({ trackName, index })}>
            <TextWrap>
              <Title>{title}</Title>
              <Desc>{desc}</Desc>
            </TextWrap>
            <CardWrap>
              <Card img={img}></Card>
            </CardWrap>
          </Block>
        ))}
        <ReturnBtn onClick={() => props.history.replace('/')}>
          返回上一页
        </ReturnBtn>
      </Content>
    </Wrap>
  );
};

export default List;
